import { createSlice } from "@reduxjs/toolkit";

import { FeaturesState } from "@/types/feature";

import { RootState } from "@/redux";

import { featureApi } from "./feature.api";

const initialState: FeaturesState = {
	features: [],
};

export const featureSlice = createSlice({
	name: "feature",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(featureApi.endpoints.getFeatures.matchFulfilled, (state, { payload }) => {
			state.features = payload;
		});
	},
});

export const featureReducer = featureSlice.reducer;
export const featureSelector = (state: RootState) => state[featureSlice.name];
